import classNames from 'classnames';
import { ErrorMessage, Field, Form as FormikForm, Formik } from 'formik';
import React, { useState } from 'react';
import Checkbox from '../form-elements/Checkbox';
import FormSection from '../form-elements/FormSection';
import Input from '../form-elements/Input';
import Notification from '../form-elements/Notification';
import Select from '../form-elements/Select';
import Textarea from '../form-elements/Textarea';
import UploadArea from '../form-elements/UploadArea';
import { JobFormValidation, submitForm } from './job.service';
const MaxCombinedUploadSize = 20_000_000;
const JobForm = ({ jobs, preselectedJobId, pageId }) => {
    const [success, setSuccess] = useState(null);
    const [error, setError] = useState(null);
    const [uploadCombinedSize, setUploadCombinedSize] = useState(0);
    return (React.createElement(Formik, { initialValues: {
            jobId: preselectedJobId ?? '',
            firstName: '',
            lastName: '',
            email: '',
            message: '',
            uploadFiles: [],
            applicationPool: false,
            privacy: false,
        }, validationSchema: JobFormValidation, onSubmit: async (values) => {
            setSuccess(null);
            setError(null);
            try {
                await submitForm(values, pageId);
                setSuccess(true);
            }
            catch (e) {
                setError(true);
            }
        } }, ({ isSubmitting, setFieldValue }) => (React.createElement(FormikForm, null,
        React.createElement(React.Fragment, null,
            React.createElement(FormSection, null,
                React.createElement(Field, { as: Select, label: 'Stelle*', name: 'jobId', placeholder: 'Bitte ausw\u00E4hlen...', options: [
                        { value: 'Initiativ', label: 'initiativ' },
                        ...jobs.map(entry => ({ value: entry.id, label: `${entry.name} - ${entry.institution}` })),
                    ] })),
            React.createElement(FormSection, { gridElementMaxWidth: '12.25rem' },
                React.createElement(Field, { as: Input, label: 'Vorname*', name: 'firstName', autoComplete: 'given-name' }),
                React.createElement(Field, { as: Input, label: 'Nachname*', name: 'lastName', autoComplete: 'family-name' })),
            React.createElement(FormSection, null,
                React.createElement(Field, { as: Input, label: 'E-Mail-Adresse*', name: 'email', autoComplete: 'email', type: 'email' }),
                React.createElement(Field, { as: Textarea, label: 'Mehr Information \u00FCber Sie*', name: 'message', rows: 4 }),
                React.createElement("div", null,
                    React.createElement("label", { className: 'form-element-label' }, "Ihre Dokumente*"),
                    React.createElement(UploadArea, { pageId: pageId, onFileListChange: list => {
                            setUploadCombinedSize(list.reduce((prev, cur) => prev + cur.size, 0));
                            setFieldValue('uploadFiles', list.map(f => f.id));
                        } })),
                React.createElement(ErrorMessage, { component: 'p', className: 'form-elements-error-message', name: 'uploadFiles' }),
                uploadCombinedSize > MaxCombinedUploadSize && (React.createElement("p", { className: 'form-elements-error-message' },
                    "Die Gesamtgr\u00F6\u00DFe Ihrer hochgeladenen Dateien d\u00FCrfen die Maximalgr\u00F6\u00DFe von",
                    ' ',
                    MaxCombinedUploadSize / 100_000,
                    "MB nicht \u00FCberschreiten. (aktuell:",
                    ' ',
                    Math.round(uploadCombinedSize / 1000 / 100) / 10,
                    "MB)"))),
            React.createElement(FormSection, null,
                React.createElement(Field, { as: Checkbox, name: 'privacy' },
                    React.createElement("span", null,
                        "Informationen zur Verarbeitung Ihrer personenbezogenen Daten bei Nutzung des Kontaktformular finden Sie in unserer",
                        React.createElement("a", { href: '/datenschutz', target: '_blank', rel: 'noopener noreferrer' }, "Datenschutzerkl\u00E4rung"),
                        ' ',
                        "."))),
            React.createElement(FormSection, null,
                React.createElement(Field, { as: Checkbox, name: 'applicationPool' },
                    React.createElement("span", null,
                        "Ich stimme zu, dass meine Daten gem\u00E4\u00DF",
                        ' ',
                        React.createElement("a", { href: '/datenschutz', target: '_blank', rel: 'noopener noreferrer' }, "Datenschutzerkl\u00E4rung"),
                        ' ',
                        "in dem St. Josef Bewerberpool aufgenommen und gespeichert werden d\u00FCrfen."))),
            !success && (React.createElement("div", { className: 'submit-btn-container' },
                React.createElement("button", { type: 'submit', className: classNames('btn is-secondary', { 'is-loading': isSubmitting }), disabled: uploadCombinedSize > MaxCombinedUploadSize }, "Absenden"))),
            success && (React.createElement(Notification, { type: 'success' },
                "Vielen Dank, wir haben Ihre Bewerbung erhalten.",
                React.createElement("br", null),
                "Wir werden uns in K\u00FCrze bei Ihnen melden.")),
            error && (React.createElement(Notification, { type: 'error' }, "Hier ist etwas schiefgelaufen, bitte versuchen Sie es erneut.")))))));
};
export default JobForm;
